import { inject, NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { ProductLeftSidebarComponent } from './product/sidebar/product-left-sidebar/product-left-sidebar.component';
import { ProductRightSidebarComponent } from './product/sidebar/product-right-sidebar/product-right-sidebar.component';
import { ProductNoSidebarComponent } from './product/sidebar/product-no-sidebar/product-no-sidebar.component';
import { ThreeColumnComponent } from './product/three-column/three-column.component';
import { FourImageComponent } from './product/four-image/four-image.component';
import { BundleProductComponent } from './product/bundle-product/bundle-product.component';
import { ImageOutsideComponent } from './product/image-outside/image-outside.component';

import { CollectionLeftSidebarComponent } from './collection/collection-left-sidebar/collection-left-sidebar.component';
import { CollectionRightSidebarComponent } from './collection/collection-right-sidebar/collection-right-sidebar.component';
import { CollectionNoSidebarComponent } from './collection/collection-no-sidebar/collection-no-sidebar.component';
import { CollectionInfinitescrollComponent } from './collection/collection-infinitescroll/collection-infinitescroll.component';

import { CartComponent } from './cart/cart.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { CompareComponent } from './compare/compare.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { SuccessComponent } from './checkout/success/success.component';

import { Resolver } from '../shared/services/resolver.service';
import { ProductService } from '../shared/services/product.service';

import { catchError, throwError } from 'rxjs';
import { AuthGuard } from '../core/auth/auth.guard';

const categoryResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const _productService = inject(ProductService);
    const router = inject(Router);

    return _productService.getCategoryById(route.paramMap.get('slug')).pipe(
       catchError((error) => {
          console.error(error);

          const parentUrl = state.url.split('/').slice(0, -1).join('/');

          router.navigateByUrl(parentUrl);

          return throwError(() => error);
       })
    );
 };

 const subcategoryResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const _productService = inject(ProductService);
    const router = inject(Router);

    const categorySlug = route.paramMap.get('slug');
    const subcategorySlug = route.paramMap.get('subcategorySlug');

    return _productService.getSubCategoryById(categorySlug, subcategorySlug).pipe(
       catchError((error) => {
          console.error(error);

          const parentUrl = state.url.split('/').slice(0, -2).join('/');

          router.navigateByUrl(parentUrl);

          return throwError(() => error);
       })
    );
 };

const routes: Routes = [

   {
      // collection/left/sidebar
      path: 'categories/:slug',
      component: CollectionLeftSidebarComponent,
      resolve: {
         category: categoryResolver,
      },
   },
   {
      path: 'categories/:slug/:subcategorySlug',
      component: CollectionLeftSidebarComponent,
      resolve: {
         category: subcategoryResolver,
      },
   },

   {
      path: 'product/:slug',
      component: ProductLeftSidebarComponent,
   },
   {
      path: 'cart',
      component: CartComponent
   },
   {
      path: 'wishlist',
      component: WishlistComponent
   },
   {
      path: 'compare',
      component: CompareComponent
   },
   {
      path: 'checkout',
      component: CheckoutComponent,
      canActivate: [AuthGuard]
   },
   {
      path: 'checkout/success/:id',
      component: SuccessComponent,
      resolve: {
         category: categoryResolver,
      },
   }
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule]
})
export class ShopRoutingModule { }
